<script setup lang="ts" generic="F extends Record<string, unknown>">
import { PV } from "@/widgets";
import type { FilterController } from "../filter";

const props = defineProps<{
    controller: FilterController<F>;
}>();

const emits = defineEmits<{
    resetFilter: [];
    applyFilter: [];
}>();
</script>

<template>
    <div class="flex flex-row gap-2 justify-end">
        <PV.Button
            v-if="props.controller.activeCount.value > 0"
            :disabled="props.controller.isLoading.value"
            icon="pi pi-times-circle"
            label="Reset"
            severity="danger"
            size="small"
            @click="emits('resetFilter')"
        />
        <PV.Button
            :disabled="!props.controller.applicable.value || props.controller.isLoading.value"
            icon="pi pi-check-circle"
            label="Terapkan"
            severity="success"
            size="small"
            @click="emits('applyFilter')"
        />
    </div>
</template>
